// a simple way to test the type and value of a param value
export function isBooleanTrue(value: boolean) {
	return value;
}
